import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { AuthService } from "app/auth/auth.service";
import Company from "models/company-details/company";
import CompanyLocation from "models/company-details/company-location";
import SortOptions from "models/content-wrapper/sort-options";
import { UtilityService } from "providers/utility-service/utility-service";
import { CompanyManagementService } from "../../../../providers/company-management-service/company-management-service";

@Component({
  selector: "company-details-companyLocations",
  templateUrl: "company-details-companyLocations.html",
})
export class CompanyDetailsLocationGroups implements OnInit {
  /** Asks the host page (CompanyDetailsPage) to open this location in the Facility
   *  form. The grid stays navigation-free; the page owns the NavController. */
  @Output() editLocation = new EventEmitter<CompanyLocation>();

  locationGroupPageData: CompanyLocation[];
  totalPageCount = 0;
  currentPage = 0;
  query: string = "";
  private request: any = {};
  private pageSize: number = 10;
  private sortOptions: SortOptions = new SortOptions("name", "asc");
  private company: Company | undefined;

  constructor(
    protected companyManagementService: CompanyManagementService,
    private utilityService: UtilityService,
    private authSvc: AuthService
  ) {
    this.company = this.authSvc.getCompany();
  }

  ngOnInit() {
    this.onPageChange(0);
  }

  ionViewDidLoad() {
    this.onPageChange(0);
  }

  loadFilters() {
    this.request = {};
    this.request.entityType = "LOCATION";
    this.request.mustFields = [
      {
        name: "pk",
        value: `COMPANY#${this.company.companyId}`,
      },
    ];
    this.request.from = this.currentPage * this.pageSize;
    this.request.size = this.pageSize;
    this.request.sortBy = {
      name: this.sortOptions.column,
      value: this.sortOptions.direction,
    };
    if (this.query) {
      this.request.search = this.query;
    }
  }

  onPageChange(selectedPage: number) {
    this.currentPage = selectedPage;
    this.utilityService.increaseSpinnerCount();
    this.loadFilters();

    this.locationGroupPageData = [];
    this.companyManagementService.getCompanyLocations(this.request).subscribe(
      (response) => {
        const hits = response && response["hits"];
        const totalHits = (response && response["totalHits"]) || 0;

        // totalHits must be read INSIDE the null guard: a null body used to throw
        // here, which skipped decreaseSpinnerCount() below and left the spinner up
        // over a grid stuck on "No Locations found". A hits-less {} body also made
        // totalPageCount NaN, which then fed grid-pager's [totalPages].
        this.locationGroupPageData =
          hits && totalHits > 0 ? (hits as CompanyLocation[]) : [];
        this.totalPageCount =
          totalHits > 0 ? Math.ceil(totalHits / this.pageSize) : 0;
        this.utilityService.decreaseSpinnerCount();
      },
      (err) => {
        this.totalPageCount = 0;
        this.utilityService.decreaseSpinnerCount();
      }
    );
  }

  arrowClick(location: CompanyLocation): void {
    location.selected = !location.selected;
  }

  onEdit(event: any, location: CompanyLocation): void {
    // Don't let the click bubble to the row and toggle the expand panel as well.
    if (event && event.stopPropagation) event.stopPropagation();
    this.editLocation.emit(location);
  }

  trackByVendorName(index: number, vendor: any) {
    return vendor.name + index;
  }

  launchVendor(url: string): void {
    window.open(url, "_blank");
  }
}



// WEBPACK FOOTER //
// ./src/pages/company/company-details/companyLocations/company-details-companyLocations.ts